import React from "react";
import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { formatDatev3, createInvoiceId, extractUsername } from "utils/common";
import styles from "./style";
import facebookIcon from "assets/images/fb.png";
import instagramIcon from "assets/images/insta.png";
import twitterIcon from "assets/images/twitter.png";

const Header = ({ user }) => {
  return (
    <View style={styles.header}>
      <Image
        style={styles.logoImage}
        // src={user.logo}
        src="https://firebasestorage.googleapis.com/v0/b/diet-app-dev-81f5b.appspot.com/o/logo%2FmetaLogo.png?alt=media&token=a23f1d1c-8a96-45d3-b8f0-f53e9cf3cc4f"
      />
      <Text style={styles.title}>INVOICE</Text>
    </View>
  );
};

const HeaderContent = ({ user }) => {
  return (
    <>
      <View style={styles.headerContent}>
        <View style={styles.detailsColumn}>
          <Text style={styles.company}>Arpit Soni</Text>
          <Text style={styles.company}>Creware Technologies</Text>
          <Text style={{ ...styles.company, ...styles.address }}>
            150/21, Mansarovar, Shipra Path 1
          </Text>
          <Text style={styles.company}>Phone: 9953307846</Text>
          <Text style={styles.company}>Email: arpit@creware.asia</Text>
        </View>

        <View style={styles.detailsColumn}>
          <Text style={styles.company}>{user.name}</Text>
          {user.firmName && <Text style={styles.company}>{user.firmName}</Text>}
          <Text style={styles.company}>{user.phoneNumber}</Text>
          <Text style={styles.company}>{user.email}</Text>
          {user.gstNumber && (
            <Text style={styles.company}>GSTIN: {user.gstNumber}</Text>
          )}
        </View>
      </View>
      <View style={styles.invoiceContainer}>
        <View style={styles.headerRow}>
          <Text style={styles.invoice}>INVOICE #</Text>
          <Text style={styles.date}>DATE</Text>
        </View>
        <View style={styles.dataRow}>
          <Text style={{ ...styles.invoice, ...styles.padding }}>
            {createInvoiceId()}
          </Text>
          <Text style={{ ...styles.date, ...styles.padding }}>
            {formatDatev3(new Date())}
          </Text>
        </View>
      </View>
    </>
  );
};

const SubscriptionContent = ({ subscription }) => {
  return (
    <View style={styles.mainDataRow}>
      <View style={{ ...styles.desc, ...styles.borderRightTop, width: "14%" }}>
        <Text>{subscription.subscriptionType || subscription.plan}</Text>
      </View>

      <View style={{ ...styles.qty, ...styles.borderRightTop, width: "14%" }}>
        <Text>{subscription.subscriptionAmount}</Text>
      </View>

      <View style={{ ...styles.unit, ...styles.borderRightTop, width: "12%" }}>
        <Text>{subscription.gstAmount || 0}</Text>
      </View>

      <View style={{ ...styles.unit, ...styles.borderRightTop, width: "14%" }}>
        <Text>{subscription.amountPaid}</Text>
      </View>

      <View
        style={{ ...styles.amount, ...styles.borderRightTop, width: "14%" }}
      >
        <Text>{subscription.referAmount}</Text>
      </View>

      <View
        style={{ ...styles.amount, ...styles.borderRightTop, width: "16%" }}
      >
        <Text>{subscription.dateOfSubscription}</Text>
      </View>

      <View
        style={{ ...styles.amount, ...styles.borderRightTop, width: "16%" }}
      >
        <Text>{subscription.nextRenewableDate}</Text>
      </View>
    </View>
  );
};

const ProductServiceSection = ({ subscription }) => {
  return (
    <>
      <View style={styles.mainRow}>
        <Text style={{ ...styles.desc, width: "14%" }}>SUBSCRIPTION TYPE</Text>
        <Text style={{ ...styles.desc, width: "14%" }}>BASE AMOUNT</Text>
        <Text style={{ ...styles.desc, width: "12%" }}>GST</Text>
        <Text style={{ ...styles.desc, width: "14%" }}>TOTAL PAID</Text>
        <Text style={{ ...styles.desc, width: "14%" }}>REDEEMED AMOUNT</Text>
        <Text style={{ ...styles.desc, width: "16%" }}>
          DATE OF SUBSCRIPTION
        </Text>
        <Text style={{ ...styles.desc, width: "16%" }}>NEXT RENEWAL DATE</Text>
      </View>

      <SubscriptionContent subscription={subscription} />
    </>
  );
};

const Socials = ({ user }) => {
  // Extract usernames from social media URLs
  const facebookUsername = user.fb ? extractUsername(user.fb) : "";
  const twitterUsername = user.twitter ? extractUsername(user.twitter) : "";
  const instagramUsername = user.instagram
    ? extractUsername(user.instagram)
    : "";
  return (
    <View style={styles.footer}>
      {/* <View style={styles.termText}>
                <Text style={styles.termsText1}>Terms & conditions: </Text>
                <Text style={styles.termsText2}>{note}</Text>
            </View> */}
      <Text style={styles.footerText}>Thank you for your business!</Text>
      <View style={styles.socialMedia}>
        {/* {user.fb && ( */}
        <View style={styles.socialMedia}>
          <Image src={facebookIcon} style={styles.icon} />
          <Text style={styles.username}>
            {/* @{facebookUsername} */}
            @arpitsoni09
          </Text>
        </View>
        {/* )} */}
        {/* {user.twitter && ( */}
        <View style={styles.socialMedia}>
          <Image src={twitterIcon} style={styles.icon} />
          <Text style={styles.username}>
            {/* @{twitterUsername} */}
            @arpitsoni09
          </Text>
        </View>
        {/* )} */}
        {/* {user.instagram && ( */}
        <View style={styles.socialMedia}>
          <Image src={instagramIcon} style={styles.icon} />
          <Text style={styles.username}>
            {/* @{instagramUsername} */}
            @arpitsoni09
          </Text>
        </View>
        {/* )} */}
      </View>

      {/* {user?.signature && user.signature !== "" && ( */}
      <View style={styles.termSig}>
        <View>
          <Image
            style={styles.signature}
            // src={user.signature}
            src="https://firebasestorage.googleapis.com/v0/b/diet-app-ceadb.appspot.com/o/signature%2Fdownload%20signa.png?alt=media&token=a73b1c22-4a6b-4bfe-826b-e0b5911c8394"
          />
          <Text style={styles.termsText1}>Authority Signature</Text>
        </View>
      </View>
      {/* )} */}
    </View>
  );
};

const Footer = ({ user }) => {
  return (
    <View style={styles.contact}>
      <Text>If you have questions about this invoice, please contact</Text>
      {/* <Text style={styles.details}>{user.name}, {user.phoneNumber}, {user.email}</Text> */}
      <Text style={styles.details}>
        Arpit Soni, 9953307846, arpit@creware.asia
      </Text>
      {/* {user.qr && user.qr !== "" && <Image style={styles.qr} src={user.qr} />} */}
    </View>
  );
};

// Create Document Component
const MyDocument = ({ user, subscription }) => {
  return (
    <Document>
      <Page style={styles.page} size="A3">
        <Header user={user} />
        <HeaderContent user={user} />
        <ProductServiceSection subscription={subscription} />
        <Footer user={user} />
        <Socials user={user} />
      </Page>
    </Document>
  );
};

export default MyDocument;
